import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { ReactNode, useState } from "react";

export type APTabDetails = {
  id?: string;
  label: ReactNode;
  ariaLabel?: string;
  children: ReactNode;
};

const getTabId = (tab: APTabDetails, index: number) =>
  tab.id ?? `index-${index}`;

const APTabs = ({
  tabs,
  initialTabId,
}: {
  tabs: APTabDetails[];
  initialTabId?: string;
}) => {
  const [selectedId, setSelectedId] = useState<string | null>(
    initialTabId ?? null
  );

  const selectedIndex = (() => {
    if (selectedId !== null) {
      const index = tabs.findIndex(
        (tab, index) => getTabId(tab, index) === selectedId
      );

      if (index !== -1) {
        return index;
      }
    }

    return 0;
  })();

  const renderTab = (tab: APTabDetails, key: number) => {
    const selected = selectedIndex === key;

    return (
      <Grid key={getTabId(tab, key)} item>
        <Button
          size="large"
          color="primary"
          variant={selected ? "outlined" : "contained"}
          disableElevation={true}
          sx={{ color: selected ? "primary.main" : "onPrimary.main" }}
          aria-label={tab.ariaLabel}
          onClick={() => setSelectedId(getTabId(tab, key))}
        >
          {tab.label}
        </Button>
      </Grid>
    );
  };

  const renderTabPanel = (tab: APTabDetails, key: number) => {
    const selected = selectedIndex === key;

    return <Box key={getTabId(tab, key)}>{selected && tab.children}</Box>;
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box>
        <Grid container spacing={2}>
          {tabs.map((tab, i) => renderTab(tab, i))}
        </Grid>
      </Box>
      <Box sx={{ my: 2 }}>
        {tabs.map((tab, i) => renderTabPanel(tab, i))}
      </Box>
    </Box>
  );
};

export default APTabs;
